import React from "react";

// components
import LateralCard from "components/LateralCard/LateralCard";
import MenuTable from "components/MenuTable/MenuTable";

// constantes
import { BLUE_RGB } from "utils/colorsTheme";
import Filters from "./Filters";
import OverTableSearch from "./OverTableSearch";

export const LateralCardUnits = () => {
  return (
    <LateralCard key="lateralCard" isOpen={true} isLoading={false}>
      <Filters />
      <OverTableSearch />
      <MenuTable color={BLUE_RGB} />
    </LateralCard>
  );
};
